import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: "#aaa",
        boxShadow: "none",
        width: "100%",
        maxWidth: "100vw", // 确保宽度不会超出视口
        overflow: "hidden", // 防止内容溢出
        boxSizing: "border-box", // 包含 padding 和 border
      }}
    >
      <Toolbar
        sx={{
          height: "80px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0 16px", // 确保内部内容有合适的 padding
        }}
      >
        <Box
          sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          onClick={() => navigate("/")}
        >
          <Box
            component="img"
            src="/images/logo.png"
            alt="Company Logo"
            sx={{
              width: "120px",
              height: "auto",
              marginRight: "10px",
              objectFit: "contain",
              transition: "transform 0.3s",
              "&:hover": { transform: "scale(1.1)" },
            }}
          />
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              color: "white",
              whiteSpace: "nowrap",
              transition: "color 0.3s, transform 0.3s",
              "&:hover": { color: "#f97316", transform: "scale(1.1)" },
              display: { xs: "none", md: "block" },
            }}
          >
            Spring Creek Cabinetry
          </Typography>
        </Box>

        <Box
          sx={{
            marginLeft: "auto",
            display: { xs: "none", md: "flex" },
            gap: 2,
          }}
        >
          <Button
            sx={{
              color: "white",
              fontSize: "16px",
              "&:hover": { color: "#f97316" },
            }}
            onClick={() => navigate("/")}
          >
            Home
          </Button>
          <Button
            sx={{
              color: "white",
              fontSize: "16px",
              "&:hover": { color: "#f97316" },
            }}
            onClick={() => navigate("/gallery")}
          >
            Gallery
          </Button>
          <Button
            sx={{
              color: "white",
              fontSize: "16px",
              "&:hover": { color: "#f97316" },
            }}
            onClick={() => navigate("/contact")}
          >
            Contact Us
          </Button>
        </Box>

        <IconButton
          sx={{ display: { xs: "flex", md: "none" }, color: "white" }}
          onClick={toggleDrawer(true)}
        >
          <MenuIcon />
        </IconButton>

        <Drawer
          anchor="right"
          open={drawerOpen}
          onClose={toggleDrawer(false)}
          sx={{ "& .MuiPaper-root": { backgroundColor: "#aaa", color: "white" } }}
        >
          <Box
            sx={{ width: 250 }}
            role="presentation"
            onClick={toggleDrawer(false)}
            onKeyDown={toggleDrawer(false)}
          >
            <List>
              <ListItem button onClick={() => navigate("/")}>
                <ListItemText primary="Home" />
              </ListItem>
              <ListItem button onClick={() => navigate("/gallery")}>
                <ListItemText primary="Gallery" />
              </ListItem>
              <ListItem button onClick={() => navigate("/contact")}>
                <ListItemText primary="Contact Us" />
              </ListItem>
            </List>
          </Box>
        </Drawer>
      </Toolbar>
    </AppBar>
  );
};

export default Header;